{
  "REGISTER": {
    "TRY_WOOT": "建立帳號",
    "GET_STARTED": "開始使用 Chatwoot",
    "TITLE": "註冊",
    "TESTIMONIAL_HEADER": "只需一步即可向前邁進",
    "TESTIMONIAL_CONTENT": "您只差一步就能與客戶互動、留住他們並發掘新客戶。",
    "TERMS_ACCEPT": "建立帳號即表示您同意我們的<a href=\"https://www.chatwoot.com/terms\">服務條款</a>和<a href=\"https://www.chatwoot.com/privacy-policy\">隱私政策</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "使用 Google 註冊"
    },
    "COMPANY_NAME": {
      "LABEL": "公司名稱",
      "PLACEHOLDER": "輸入您的公司名稱，例如：Wayne Enterprises",
      "ERROR": "公司名稱過短。"
    },
    "FULL_NAME": {
      "LABEL": "姓名",
      "PLACEHOLDER": "輸入您的姓名，例如：Bruce Wayne",
      "ERROR": "姓名過短。"
    },
    "EMAIL": {
      "LABEL": "工作電子郵件",
      "PLACEHOLDER": "輸入您的工作電子郵件，例如：bruce{'@'}wayne{'.'}enterprises",
      "ERROR": "請輸入有效的工作電子郵件地址。"
    },
    "PASSWORD": {
      "LABEL": "密碼",
      "PLACEHOLDER": "密碼",
      "ERROR": "密碼過短。",
      "IS_INVALID_PASSWORD": "密碼應包含至少 1 個大寫字母、1 個小寫字母、1 個數字和 1 個特殊字元。",
      "REQUIREMENTS_LENGTH": "至少 6 個字元",
      "REQUIREMENTS_UPPERCASE": "至少一個大寫字母",
      "REQUIREMENTS_LOWERCASE": "至少一個小寫字母",
      "REQUIREMENTS_NUMBER": "至少一個數字",
      "REQUIREMENTS_SPECIAL": "至少一個特殊字元"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "確認密碼",
      "PLACEHOLDER": "確認密碼",
      "ERROR": "密碼不一致。"
    },
    "API": {
      "SUCCESS_MESSAGE": "註冊成功",
      "ERROR_MESSAGE": "無法連接伺服器，請再試一次。"
    },
    "SUBMIT": "建立帳號",
    "HAVE_AN_ACCOUNT": "已經有帳號了嗎？",
    "VERIFY_EMAIL": {
      "TITLE": "請查看您的收件匣",
      "DESCRIPTION": "我們已將驗證連結寄送至 {email}。請點擊連結驗證您的電子郵件並開始使用。",
      "RESEND": "重新發送驗證信件",
      "RESEND_SUCCESS": "驗證電子郵件已送出。請查看您的收件匣。",
      "RESEND_ERROR": "無法送出驗證電子郵件。請再試一次。"
    }
  }
}
